import {CreateEntity, parseDate, UpdateEntity} from './entity.model';
import {PackVersion, PackVersionModel} from './pack-version.model';
import {Visibility} from './prompt.model';
import {NamedEntity, NamedEntityModel} from './named-entity.model';

export interface Pack extends NamedEntity {
  description?: string
  version: number
  visibility: Visibility
  latest_version?: PackVersion
  created_at?: string
  updated_at?: string
}

export class PackModel extends NamedEntityModel<Pack> {
  readonly version: number;
  readonly visibility: Visibility;
  readonly description?: string;
  readonly createdAt?: Date;
  readonly updatedAt?: Date;
  readonly latestVersion?: PackVersionModel;

  constructor(source: Pack) {
    super(source, 'pack');
    this.version = source.version;
    this.visibility = source.visibility;
    this.description = source.description;
    this.createdAt = parseDate(source.created_at);
    this.updatedAt = parseDate(source.updated_at);

    if (source.latest_version) {
      this.latestVersion = new PackVersionModel(source.latest_version);
    }
  }
}

interface InitialPromptDef {
  prompt_id: string;
  version: number;
}

interface InitialPackDef {
  pack_id: string;
  version: number;
}

export interface CreatePack extends CreateEntity<Pack> {
  initial_items: (InitialPromptDef | InitialPackDef)[]
}

export type UpdatePack = UpdateEntity<Pack>
